import React from 'react'

const Footer = () => {

    const link = 'https://scottyeung.top/'

    return (
        <footer className="flex justify-center items-center bg-gray-600 py-4 absolute bottom-0 w-full">
            <a href={link} className="text-white text-xl">@YeungYeah</a>
        </footer>
    )
}

export default Footer